import { useState } from "react";
import { Wand2, Type, Smile, Trash2, Minus, Plus } from "lucide-react";
import { FILTERS, STICKERS, TEXT_COLORS } from "@/lib/filters";

const TABS = [["filters", "Filtros", Wand2], ["text", "Texto", Type], ["stickers", "Figurinhas", Smile]];

function TextTool({ onAdd }) {
  const [text, setText] = useState("");
  const [color, setColor] = useState(TEXT_COLORS[0]);
  const add = () => { if (text.trim()) { onAdd({ text: text.trim(), color }); setText(""); } };
  return (
    <div className="space-y-3">
      <div className="flex gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} maxLength={60} placeholder="Escreva algo inspirador…"
          className="h-10 flex-1 rounded-full bg-white/5 px-4 text-sm outline-none ring-1 ring-white/10 focus:ring-[hsl(var(--gold))]" data-testid="text-overlay-input" />
        <button onClick={add} className="rounded-full bg-[hsl(var(--gold))] px-4 text-sm font-bold text-[#0B0F17]" data-testid="add-text-button">Adicionar</button>
      </div>
      <div className="flex gap-2">
        {TEXT_COLORS.map((c) => (
          <button key={c} onClick={() => setColor(c)} style={{ background: c }} aria-label={`Cor ${c}`} data-testid={`text-color-${c.slice(1)}`}
            className={`h-7 w-7 rounded-full ring-2 ${color === c ? "ring-[hsl(var(--gold))]" : "ring-white/20"}`} />
        ))}
      </div>
    </div>
  );
}

export function EditTools({ edits, setEdits, selected, setSelected }) {
  const [tab, setTab] = useState("filters");
  const addItem = (kind, item) => {
    const list = [...edits[kind], item];
    setEdits({ ...edits, [kind]: list });
    setSelected({ kind, idx: list.length - 1 });
  };
  const resize = (d) => setEdits({ ...edits, [selected.kind]: edits[selected.kind].map((it, i) => (i === selected.idx ? { ...it, size: Math.max(14, Math.min(110, it.size + d)) } : it)) });
  const remove = () => { setEdits({ ...edits, [selected.kind]: edits[selected.kind].filter((_, i) => i !== selected.idx) }); setSelected(null); };

  return (
    <div className="rounded-2xl border border-white/5 bg-card p-4" data-testid="edit-tools">
      <div className="mb-4 flex gap-1.5">
        {TABS.map(([k, l, Icon]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`edit-tab-${k}`}
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold ${tab === k ? "bg-white text-black" : "bg-white/5 text-muted-foreground"}`}><Icon size={14} /> {l}</button>
        ))}
      </div>
      {tab === "filters" && (
        <div className="no-scrollbar flex gap-3 overflow-x-auto pb-1">
          {FILTERS.map((f) => (
            <button key={f.key} onClick={() => setEdits({ ...edits, filter: f.key })} className="flex shrink-0 flex-col items-center gap-1 text-[11px] font-semibold" data-testid={`filter-${f.key}`}>
              <span style={{ background: f.swatch, filter: f.css }} className={`h-12 w-12 rounded-2xl ring-2 ${edits.filter === f.key ? "ring-[hsl(var(--gold))]" : "ring-transparent"}`} />
              {f.label}
            </button>
          ))}
        </div>
      )}
      {tab === "text" && edits.texts.length < 5 && <TextTool onAdd={(t) => addItem("texts", { ...t, x: 50, y: 35 + edits.texts.length * 8, size: 28 })} />}
      {tab === "text" && edits.texts.length >= 5 && <p className="text-xs text-muted-foreground">Máximo de 5 textos.</p>}
      {tab === "stickers" && (
        <div className="grid grid-cols-6 gap-2">
          {STICKERS.map((s, i) => (
            <button key={s} onClick={() => edits.stickers.length < 12 && addItem("stickers", { emoji: s, x: 50, y: 55, size: 48 })} className="grid h-11 place-items-center rounded-xl bg-white/5 text-2xl hover:bg-white/10" data-testid={`sticker-${i}`}>{s}</button>
          ))}
        </div>
      )}
      {selected && (
        <div className="mt-4 flex items-center gap-2 border-t border-white/5 pt-3 text-xs" data-testid="overlay-selected-controls">
          <span className="text-muted-foreground">Selecionado — arraste na tela para mover</span>
          <button onClick={() => resize(-6)} className="ml-auto grid h-8 w-8 place-items-center rounded-full bg-white/10" data-testid="overlay-size-down"><Minus size={14} /></button>
          <button onClick={() => resize(6)} className="grid h-8 w-8 place-items-center rounded-full bg-white/10" data-testid="overlay-size-up"><Plus size={14} /></button>
          <button onClick={remove} className="grid h-8 w-8 place-items-center rounded-full bg-red-600" data-testid="remove-overlay-button"><Trash2 size={14} /></button>
        </div>
      )}
    </div>
  );
}
